// extracted by mini-css-extract-plugin
module.exports = {"lead":"ChangePolicyModal__lead--1JSxp","selectWrap":"ChangePolicyModal__selectWrap--3ZmDc"};